<template>
  <!-- component container -->
  <div :class="['kpi', {'kpi-big': big}, stateClass]">
      <div class="kpi-body" v-b-tooltip.hover :title="kpi.extra_description">
        <Kpivalue :value="kpi.value"
          :decimals="kpi.decimals_places"
          decimal_separator=","
          thousand_separators="."
          :units="kpi.units"
          region="es"
          classStyle="kpi-title">
        </Kpivalue>
        <h6 class="kpi-subtitle">{{ kpi.title }}</h6>
        <i :class="icon"></i>
      </div>
      <div class="kpi-footer d-flex" v-if="kpi.ref_time ? true:false">
        <div class="kpi-footer-left">
          Reference last {{ kpi.ref_time }}
        </div>
      </div>
  </div>
  <!-- component container END -->
</template>

<script>
import Kpivalue from './Kpivalue';

export default {
  name: 'Kpi',
  props: ['kpi_data'],
  components: {
    Kpivalue
  },
  data () {
    return {
      kpi_local: this.kpi_data
    };
  },
  computed: {
    stateClass () {
      if (this.kpi.indicator !== 'color') { return ''; }
      if (this.kpi.state === 'success') { return 'kpi-success'; } else if (this.kpi.state === 'danger') { return 'kpi-danger'; } else { return ''; }
    },
    kpi () {
      return this.kpi_local;
    },
    big () {
      return false;
    },
    icon () {
      if (this.kpi.indicator !== 'icon') { return ''; }
      if (this.kpi.state === 'success') { return 'fa fa-arrow-up kpi_icon'; } else if (this.kpi.state === 'danger') { return 'fa fa-arrow-down kpi_icon'; } else { return ''; }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Kpi/Kpi.vue